// 🔒 PANTALLA-ESPERA-2026-10-17 — "Toca para empezar" antes del PIN.
// La config vive en system_config.pantalla_espera (Mongo). Se guarda con
// PUT /api/system/config y el login la lee por GET /api/system/branding (pública).
// Las fotos se suben con POST /api/products/upload-image (quedan en Mongo,
// sobreviven al redeploy) y se sirven en /api/uploads/products/<id>.
export const MAX_IMAGENES = 10;
export const TEXTO_DEFAULT = 'Toca para empezar';

const entre = (v, min, max, def) => {
  const n = Number(v);
  return Number.isFinite(n) ? Math.min(max, Math.max(min, Math.round(n))) : def;
};

// Lo que se ve es lo que se guarda: misma limpieza al leer y al guardar.
export function normalizarEspera(cfg) {
  const c = cfg && typeof cfg === 'object' ? cfg : {};
  const imagenes = (Array.isArray(c.imagenes) ? c.imagenes : [])
    .filter((u) => typeof u === 'string' && u.startsWith('/api/uploads/'))
    .slice(0, MAX_IMAGENES);
  const texto = typeof c.texto === 'string' ? c.texto.trim().slice(0, 60) : '';
  return {
    activa: c.activa === true,
    modo: c.modo === 'fija' ? 'fija' : 'rotativa',
    // 🔒 PANTALLA-ESPERA-2 — 'llenar' (defecto, como antes): ocupa toda la pantalla y
    // puede recortar orillas. 'completa': la foto entera + la misma borrosa de fondo.
    ajuste: c.ajuste === 'completa' ? 'completa' : 'llenar',
    segundos: entre(c.segundos, 3, 60, 8),
    regreso: entre(c.regreso, 10, 600, 60),
    texto: texto || TEXTO_DEFAULT,
    imagenes,
  };
}
